import React from "react";
import {
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  ListItemButton,
} from "@mui/material";
import {
  Folder as FolderIcon,
  Star as StarIcon,
  FolderShared as FolderSharedIcon,
  AccessTime as AccessTimeIcon,
  NotInterested as NotInterestedIcon,
} from "@mui/icons-material";
import DeleteSweepIcon from "@mui/icons-material/DeleteSweep";
import { useTranslation } from "react-i18next";

const MainSidebarContent = ({ onRecycleBinClick }) => {
  const { t } = useTranslation();
  const translation = t("fileExplorer");
  return (
    <List component="nav">
      <ListItem disablePadding>
        <ListItemButton dense onClick={onRecycleBinClick}>
          <ListItemIcon>
            <DeleteSweepIcon sx={{ fontSize: 20 }} />
          </ListItemIcon>
          <ListItemText primary={translation.recycleBin} />
        </ListItemButton>
      </ListItem>
      <ListItem disablePadding>
        <ListItemButton dense>
          <ListItemIcon>
            <StarIcon sx={{ fontSize: 20 }} />
          </ListItemIcon>
          <ListItemText primary={translation.starred} />
        </ListItemButton>
      </ListItem>
      <ListItem disablePadding>
        <ListItemButton dense>
          <ListItemIcon>
            <FolderSharedIcon sx={{ fontSize: 20 }} />
          </ListItemIcon>
          <ListItemText primary={translation.sharedWithMe} />
        </ListItemButton>
      </ListItem>
      <ListItem disablePadding>
        <ListItemButton dense>
          <ListItemIcon>
            <AccessTimeIcon sx={{ fontSize: 20 }} />
          </ListItemIcon>
          <ListItemText primary={translation.recent} />
        </ListItemButton>
      </ListItem>
      <ListItem disablePadding>
        <ListItemButton dense>
          <ListItemIcon>
            <NotInterestedIcon sx={{ fontSize: 20 }} />
          </ListItemIcon>
          <ListItemText primary={translation.offline} />
        </ListItemButton>
      </ListItem>
    </List>
  );
};

export default MainSidebarContent;
